import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export abstract class AtLeastOneValueValidator {
  public static validator: ValidatorFn = (control: AbstractControl): ValidationErrors => {
    return Object.keys(control.value).some((key) => !!control.value[key]) ? null : { atLeastOneRequired: true };
  };
}
